<template>
  <section v-if="codeDetails">
    <h4 class="mb-5">Blacklist status</h4>
    <SoAlert class="w-50 mb-5" type="warning" data-testid="code-blacklist-info">
      <template v-if="codeDetails.isBlacklisted">
        This voucher is on the blacklist. This means the customer and their
        friend will not receive the Refer-A-Friend credit when their friend
        signs up to So Energy using their referral link.
      </template>
      <template v-else>
        By adding this voucher to the blacklist, the voucher will not work. This
        means the customer and their friend will not receive the Refer-A-Friend
        credit when their friend signs up to So Energy using their referral
        link. Do not put a voucher code in the blacklist without informing the
        customer
      </template>
    </SoAlert>
    <SoButton
      ref="toggle-blacklist-btn"
      type="primary"
      :title="
        codeDetails.isBlacklisted ? `Remove from blacklist` : `Add to blacklist`
      "
      :loading="toggleBlacklistMutation.isPending"
      data-testid="toggle-blacklist-btn"
      large
      @click="toggleBlacklistStatus(codeDetails.isBlacklisted)"
    />
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { ReferralMutator } from "@/mutators/referral/ReferralMutator"
  import { ReferralCodeDetail } from "@/models/operations/referralCodeDetails/referralCodeDetails"

  export default defineComponent({
    components: { SoButton, SoAlert },
    props: {
      codeDetails: {
        type: Object as PropType<ReferralCodeDetail | null>,
        required: true,
      },
    },
    data() {
      return {
        toggleBlacklistMutation: ReferralMutator.toggleCodeBlacklistStatus(),
      }
    },
    methods: {
      toggleBlacklistStatus(isWhitelisted: boolean) {
        if (!this.codeDetails?.referrer.customerNumber) return

        this.toggleBlacklistMutation.mutate({
          number: this.codeDetails?.referrer.customerNumber,
          isWhitelisted,
        })
      },
    },
  })
</script>
